import React from 'react'
import * as ItemTypes from '@disco/constants/ItemTypes'
import PreviewList from '../preview-list'
const maxPreviewItems = 5

// don't rerender component if parent tree changes, we only care about our own
// props here
/**
 * Drag preview component for multiple selected items with count summary
 * Shows a preview list of dragged items with overflow count for large selections
 * Optimized with PureComponent to prevent unnecessary re-renders
 * @param item - Currently dragged item
 * @param type - Type of items being dragged (TRACK or PLAYLIST)
 * @param selectedItemsCount - Total number of selected items
 * @param previewItems - Array of items to show in preview (limited to maxPreviewItems)
 * @param dragPreviewStyle - CSS styles for the drag preview container
 */
class DragPreview extends React.PureComponent<any> {
  render() {
    const { type, selectedItemsCount, previewItems, dragPreviewStyle } =
      this.props

    if (
      ![ItemTypes.TRACK, ItemTypes.PLAYLIST, ItemTypes.BRIEF].includes(type)
    ) {
      return null
    }
    const moreItems =
      selectedItemsCount > maxPreviewItems ? (
        <div className="DragPreview_Summary">
          {selectedItemsCount - maxPreviewItems > 1
            ? `and ${selectedItemsCount - maxPreviewItems} other items...`
            : `and ${selectedItemsCount - maxPreviewItems} other item...`}
        </div>
      ) : null
    return (
      <div className="DragPreview" style={dragPreviewStyle}>
        <PreviewList list={previewItems} />
        {moreItems}
      </div>
    )
  }
}

export default DragPreview
